// removed by extract-text-webpack-plugin
module.exports = {"image":"KioskImage__image___1SHJO"};